/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandortDetailDto } from '../../models/lexplus-standort-detail-dto';

export interface StandorteControllerFindDetailV1$Params {
  standortId: number;
  kundeId: number;
}

export function standorteControllerFindDetailV1(http: HttpClient, rootUrl: string, params: StandorteControllerFindDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandortDetailDto>> {
  const rb = new RequestBuilder(rootUrl, standorteControllerFindDetailV1.PATH, 'get');
  if (params) {
    rb.path('standortId', params.standortId, {});
    rb.query('kundeId', params.kundeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandortDetailDto>;
    })
  );
}

standorteControllerFindDetailV1.PATH = '/v1/standorte/{standortId}';
